import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Tile} from "../../Tile";
import {interval, Subscription} from "rxjs";
import {AnalogOutDescription, AOutDescription} from "../analogoutDescription";
import {AnalogoutdetailsComponent} from "../analogoutdetails/analogoutdetails.component";
import {AnalogOutDescriptionDataservice} from "../analogout-description-dataservice";
import {AnalogOutStatusDataservice} from "../analogout-status-dataservice";
import {AnalogOutStatus, AOState} from "../analogoutStatus";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-analogoutlist',
  templateUrl: './analogoutlist.component.html',
  styleUrls: ['./analogoutlist.component.css']
})
export class AnalogoutlistComponent implements OnInit, OnDestroy {
  tiles: Tile[] = [
    {text: 'Tile 1', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double purple'},
    {text: 'Tile 2', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double red'},
    {text: 'Tile 3', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double skyblue'},
    {text: 'Tile 4', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double yellow'},
  ];

  @Input()
  aOutDescription: AnalogOutDescription | undefined;
  aOutStatus: AnalogOutStatus | undefined;
  private updateSubscription: Subscription | undefined;
  errorMessage: string = "";
  componentList = Array<AnalogoutdetailsComponent>();
  public loaderStatus: number = 0;

  constructor(private analogOutDescriptionDataservice: AnalogOutDescriptionDataservice,
              private analogOutStatusDataservice: AnalogOutStatusDataservice           )  {
  }

  InitLayout(): void {
    this.analogOutDescriptionDataservice.GetData().subscribe({
      next: aOutDescription => {
        this.aOutDescription = aOutDescription;
        this.componentList.forEach((detail => {
          console.log('Node update');
          detail.UpdateLayoutData(this.GetDescription(detail.refNumber));
        }))
      },
      error: err => this.errorMessage = err
    });
  }

  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;
    this.analogOutStatusDataservice.GetData().subscribe(
      {
        next: aOutStatus => {
          this.loaderStatus = 1;
          this.aOutStatus = aOutStatus;
          for(let detail of this.componentList) {
            detail.UpdateDiState(this.GetStatus(detail.refNumber));
          }
          this.ReSubscribe();
        }, error: err => { this.errorMessage = err;
        }
      });
  }

  ngOnInit(): void {
    this.InitLayout();
    this.UpdateData();
  }
  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

  Add(analogOutDetail: AnalogoutdetailsComponent): void
  {
    this.componentList.push(analogOutDetail);
  }

  GetDescription(refNumber: number): AOutDescription {
    if( ( this.aOutDescription) && (this.aOutDescription.AO[refNumber]))
      return this.aOutDescription.AO[refNumber];
    return new AOutDescription();
  }

  GetStatus(refNumber: number): AOState {
    if( ( this.aOutStatus) && (this.aOutStatus.AO[refNumber]))
      return this.aOutStatus.AO[refNumber];
    return new AOState();
  }


}

